import imageFields from "./imageFields"

export default `
  seoTitle
  seoDescription
  ogTitle
  ogDescription
  ogImage {
    ${imageFields}
  }
  featuredImage {
    ${imageFields}
  }
  hidePageFromSearchEnginesNoIndex
  excludeLinksFromSearchRankingsNofollow
  canonicalUrl
`
